<template>
  <section class="container-fluid">
    <div class="logo_section">
      <img src="../assets/Images/logo.png" alt="" width="120" />
    </div>
    <div class="container">
      <div class="row align-content-center justify-content-center text-center">
        <div class="link-expired_content">
          <h3 class="font-weight-800 mb-2">Hurray!! Welcome to the team !!</h3> 
          <p class="text-muted">
            Your email has been verified successfully and you have already
            accepted the terms and conditions.
          </p>
          <div class="mt-4">
            <img src="../assets/Images/invitation.png" alt="" width="200" />
          </div>
          <div class="login_button_area mt-4">
            <router-link
              :to="{ name: 'Login' }"
              class="btn btn-primary btn-Agree my-3"
              type="submit"
              @click="submit"
              >Next
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="">
      <img src="../assets/Images/Vector.png" alt="" class="Vector_one_img" />
      <img
        src="../assets/Images/Vector2.png"
        alt=""
        class="Vector_secand_img"
      />
      <img src="../assets/Images/Vector4.png" alt="" class="Vector_fore_img" />
      <img src="../assets/Images/Vector3.png" alt="" class="Vector_three_img" />
    </div>
  </section>
</template>
<script>
export default {
  name: "Invitation",
};
</script>
<style lang="css">
@import url("/assets/css/style.css");
@import url("/assets/css/responsive.css");
</style>
